import { CellPhoneProvidersConstants } from "types/constants";

import yup from "utilities/form/yup";

/**
 * Helper function returns validation schema for cell email lookup
 */
export const cellEmailLookupValidator = yup
    .string()
    .test("cell_email", "Required", (value: string) => {
        return (
            value === undefined ||
            value === "" ||
            (value.includes("@") &&
                !value.includes(CellPhoneProvidersConstants.NoCarrierReturned) &&
                !value.includes(CellPhoneProvidersConstants.NoProviderDomain))
        );
    })
    .label("Service Provider");
